import {axios} from "@/utils"

const endpoints = {
    photobook: "/photobook-preview/",
}

export default {
     async getPhotobook(params) {
        const response = await axios.get(endpoints.photobook, {params})
        return response.data
    },
}